import classNames from "classnames";
import { useState } from "react";
import { Checkbox, Table } from "rsuite";
import { MappedDomain } from "../../../api/api-hooks/brie/useDomainMapper";

interface Props {
  mappedData: MappedDomain[];
  handleCheckAll: (value: any, checked: any) => void;
  handleCheck: (value: any, checked: any) => void;
  checkedKeys: any;
}

const BrieDomainMapperTable = ({
  mappedData,
  handleCheckAll,
  handleCheck,
  checkedKeys,
}: Props) => {
  const NameCell = ({ rowData, dataKey, ...props }: any) => {
    return (
      <Cell {...props} className="">
        <span
          className={classNames({
            "text-primary": dataKey === "companyName",
          })}
        >
          {rowData[dataKey]}
        </span>
      </Cell>
    );
  };

  const CheckCell = ({
    rowData,
    onChange,
    checkedKeys,
    dataKey,
    ...props
  }: any) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: "46px" }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item: any) => item === rowData[dataKey])}
          />
        </div>
      </Cell>
    );
  };

  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === mappedData.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < mappedData.length) {
    indeterminate = true;
  }
  const { Column, HeaderCell, Cell } = Table;

  return (
    <Table height={300} data={mappedData} id="table">
      <Column width={50} align="center">
        <HeaderCell style={{ padding: 0, backgroundColor: "#E8EDEA" }}>
          <div style={{ lineHeight: "40px" }}>
            <Checkbox
              inline
              checked={checked}
              indeterminate={indeterminate}
              onChange={handleCheckAll}
            />
          </div>
        </HeaderCell>
        <CheckCell
          dataKey="key"
          checkedKeys={checkedKeys}
          onChange={handleCheck}
        />
      </Column>

      <Column width={300}>
        <HeaderCell
          className="font-weight-bolder"
          style={{ backgroundColor: "#E8EDEA" }}
        >
          Email
        </HeaderCell>
        <NameCell dataKey="Email" />
      </Column>
      <Column width={300}>
        <HeaderCell
          className="font-weight-bolder"
          style={{ backgroundColor: "#E8EDEA" }}
        >
          Contact
        </HeaderCell>
        <NameCell dataKey="_RecordName" />
      </Column>
      <Column width={300}>
        <HeaderCell
          className="font-weight-bolder"
          style={{ backgroundColor: "#E8EDEA" }}
        >
          Matched Company
        </HeaderCell>
        <NameCell dataKey="companyName" />
      </Column>
    </Table>
  );
};

export default BrieDomainMapperTable;
